import React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ProfileCard, { DetailRow, NotProvided } from "./ProfileCard";
import { addressLines } from "./profileModel";

const Locked = () => (
  <span className="pf-lock"><LockOutlinedIcon sx={{ fontSize: 12 }} />Set by your training center</span>
);

export function PersonalCard({ details, memberId, editing, saving, onEdit, onCancel, onSave, onChange }) {
  return (
    <ProfileCard id="personal" title="Personal details" editing={editing} saving={saving} onEdit={onEdit} onCancel={onCancel} onSave={onSave}>
      <dl className="pf-dl">
        <DetailRow label="Full name" htmlFor={editing ? "pf-fullName" : undefined}>
          {editing ? (
            <input id="pf-fullName" className="pf-in" value={details.fullName || ""} onChange={onChange("fullName")} />
          ) : (
            details.fullName || <NotProvided />
          )}
        </DetailRow>
        <DetailRow label="Username" htmlFor={editing ? "pf-username" : undefined}>
          {editing ? (
            <>
              <input id="pf-username" className="pf-in" value={details.username || ""} readOnly />
              <Locked />
            </>
          ) : (
            <span className="pf-mono">{details.username || "—"}</span>
          )}
        </DetailRow>
        <DetailRow label="Member ID">
          <span className="pf-mono">{memberId}</span>
        </DetailRow>
      </dl>
    </ProfileCard>
  );
}

export function ContactCard({ details, email, editing, saving, onEdit, onCancel, onSave, onChange, onChangeEmail }) {
  const lines = addressLines(details);
  return (
    <ProfileCard
      id="contact"
      title="Contact information"
      subtitle="Used for class reminders and certification notices."
      editing={editing}
      saving={saving}
      onEdit={onEdit}
      onCancel={onCancel}
      onSave={onSave}
    >
      <dl className="pf-dl">
        <DetailRow label="Email">
          {email || <NotProvided />}
          <button type="button" className="pf-btn pf-btn-g pf-btn-sm" onClick={onChangeEmail}>Change email</button>
        </DetailRow>
        <DetailRow label="Phone" htmlFor={editing ? "pf-phone" : undefined}>
          {editing ? (
            <input id="pf-phone" className="pf-in" type="tel" placeholder="(555) 555-0123" value={details.phone || ""} onChange={onChange("phone")} />
          ) : (
            details.phone || <NotProvided />
          )}
        </DetailRow>
        <DetailRow label="Primary residence" htmlFor={editing ? "pf-addressLine1" : undefined}>
          {editing ? (
            <div className="pf-addr">
              <input id="pf-addressLine1" className="pf-in" aria-label="Address line 1" placeholder="Street address" value={details.addressLine1 || ""} onChange={onChange("addressLine1")} />
              <input className="pf-in" aria-label="Address line 2" placeholder="Apt, suite, unit" value={details.addressLine2 || ""} onChange={onChange("addressLine2")} />
              <div className="row">
                <input className="pf-in" aria-label="City" placeholder="City" value={details.city || ""} onChange={onChange("city")} />
                <input className="pf-in" aria-label="State" placeholder="State" value={details.state || ""} onChange={onChange("state")} />
                <input className="pf-in" aria-label="ZIP code" placeholder="ZIP" value={details.zip || ""} onChange={onChange("zip")} />
              </div>
            </div>
          ) : lines.length ? (
            <span className="pf-lines">{lines.map((l) => <span key={l}>{l}</span>)}</span>
          ) : (
            <NotProvided />
          )}
        </DetailRow>
      </dl>
    </ProfileCard>
  );
}
